import { useState } from 'react'

/**
 * Take a visiting dancer back off tonight (D-806).
 *
 * **The undo for a wrongly-tapped drop-in.** Nothing in this codebase deleted
 * an attendance record before D-806, so a mis-added dancer was permanent —
 * while the add endpoint already *instructed* the removal it could not
 * perform: *"Remove her from this session first, then add her again."* A
 * sentence pointing at a control nobody built, which is what the reopen button
 * was (D-792).
 *
 * **Shared rather than written twice.** Both registers need it — the teacher's
 * own panel and the wall tablet — and the second copy of an idea never
 * receives the first one's fixes. The wording is the part most likely to
 * drift, and the wording is the whole safeguard here.
 *
 * **It asks first, and the question names what it undoes.** `asked`,
 * 2026-09-23: *"removing a visitor should be allowed even if marked there just
 * note what it would do."* So it is allowed whatever is marked — the realistic
 * mistake is the wrong Ava tapped and then marked *Here* out of habit, and a
 * rule that refused once she was marked would refuse exactly the mistakes
 * people make.
 *
 * **The absence coming back is the half she cannot see.** Removing the row
 * takes the dancer off the register, which is obvious on screen; it also hands
 * the missed class back to needing a make-up, which is not on this screen at
 * all — so the confirm says it out loud.
 */
export default function TakeOffTheNight({
  name,
  onRemove,
}: {
  name: string
  onRemove: () => void
}) {
  const [asked, setAsked] = useState(false)

  if (!asked) {
    return (
      <button
        type="button"
        onClick={() => setAsked(true)}
        className="mt-1 min-h-[24px] text-[12.5px] font-semibold text-ink-3 underline underline-offset-2 hover:text-ink"
      >
        Take off this night
      </button>
    )
  }

  return (
    <div className="mt-1.5 flex flex-wrap items-center gap-2">
      {/*
        <b>The name, never a pronoun</b> (D-807). This said *"anything she was
        making up"* when it was written an hour earlier — the same assumption
        the owner had just reported one component over, reproduced immediately
        by the person fixing it. The studio is mostly girls and the habit is
        strong; the name is already in the sentence, so there is no cost to it.
      */}
      <span className="text-[12.5px] text-ink-2">
        Take {name} off? Anything they were making up goes back to needing one.
      </span>

      <button
        type="button"
        onClick={() => {
          setAsked(false)
          onRemove()
        }}
        className="min-h-[32px] rounded-lg border border-warn bg-warn-bg px-2.5 py-1 text-[12.5px] font-bold text-warn"
      >
        Yes, take her off
      </button>

      <button
        type="button"
        onClick={() => setAsked(false)}
        className="min-h-[32px] px-1.5 py-1 text-[12.5px] font-semibold text-ink-2"
      >
        Cancel
      </button>
    </div>
  )
}
